// 📄 components/StepConfirmExit.tsx
import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { ConfirmationFormData } from '../../../../../services/commerce/integrationService';

interface StepConfirmExitProps {
  exitMM06E001Active: boolean;
  include01Added: boolean;
  include02Added: boolean;
  onChange: (field: keyof ConfirmationFormData, value: any) => void;
}

export function StepConfirmExit({ exitMM06E001Active, include01Added, include02Added, onChange }: StepConfirmExitProps) {
  return (
    <div className="space-y-4 animate-fadeIn">
      <div className="bg-blue-500/5 border border-blue-500/10 rounded-xl p-3 mb-2 space-y-1">
        <span className="text-[10px] font-bold text-blue-400 uppercase tracking-widest block">Ruta SPRO / Transacción SAP</span>
        <p className="font-mono text-xs text-gray-300">
          <span className="bg-zinc-800 px-1.5 py-0.5 rounded text-gray-400 font-bold mr-1.5">CMOD / SMOD</span>
          <span>SAP Menu → Tools → ABAP Workbench → Utilities → Enhancements → Project Management</span>
        </p>
      </div>

      <div>
        <h3 className="text-lg font-medium text-blue-400">2. Implement Custom Exit (User Exits de Confirmación)</h3>
        <p className="text-sm text-gray-400">
          Activa el enhancement <code className="bg-black/30 px-1 rounded">MM06E001</code> y agrega el código de los includes en los exits correspondientes para procesar la confirmación de pedido entrante.
        </p>
      </div>

      <div className="bg-white/5 p-4 rounded-xl border border-white/5 space-y-4">
        <div className="flex items-center justify-between gap-4">
          <div>
            <label className="block text-sm font-medium text-white">Enhancement <code className="bg-black/30 px-1 rounded font-mono text-blue-400">MM06E001</code> activo</label>
            <p className="text-xs text-gray-400 mt-0.5">
              Exits: <code className="bg-black/30 px-1 rounded font-mono">EXIT_SAPLEINM_007</code> y <code className="bg-black/30 px-1 rounded font-mono">EXIT_SAPLEINM_008</code>
            </p>
          </div>
          <label className="relative inline-flex items-center cursor-pointer flex-shrink-0">
            <input
              type="checkbox"
              checked={exitMM06E001Active || false}
              onChange={(e) => onChange('exitMM06E001Active', e.target.checked)}
              className="sr-only peer"
            />
            <div className="w-9 h-5 bg-zinc-700 rounded-full peer peer-checked:after:translate-x-full peer-checked:bg-blue-500 after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:rounded-full after:h-4 after:w-4 after:transition-all"></div>
          </label>
        </div>

        <div className="border-t border-white/5 pt-3 flex items-center justify-between gap-4">
          <div>
            <label className="block text-sm font-medium text-white">Include <code className="bg-black/30 px-1 rounded font-mono text-blue-400">ZXM06U19</code> agregado</label>
            <p className="text-xs text-gray-400 mt-0.5 font-mono">INCLUDE ARBCIG_INCL_ORDER_CONFIRM_01 IF FOUND</p>
          </div>
          <label className="relative inline-flex items-center cursor-pointer flex-shrink-0">
            <input
              type="checkbox"
              checked={include01Added || false}
              onChange={(e) => onChange('include01Added', e.target.checked)}
              className="sr-only peer"
            />
            <div className="w-9 h-5 bg-zinc-700 rounded-full peer peer-checked:after:translate-x-full peer-checked:bg-blue-500 after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:rounded-full after:h-4 after:w-4 after:transition-all"></div>
          </label>
        </div>

        <div className="border-t border-white/5 pt-3 flex items-center justify-between gap-4">
          <div>
            <label className="block text-sm font-medium text-white">Include <code className="bg-black/30 px-1 rounded font-mono text-blue-400">ZXM06U20</code> agregado</label>
            <p className="text-xs text-gray-400 mt-0.5 font-mono">INCLUDE ARBCIG_INCL_ORDER_CONFIRM_02 IF FOUND</p>
          </div>
          <label className="relative inline-flex items-center cursor-pointer flex-shrink-0">
            <input
              type="checkbox"
              checked={include02Added || false}
              onChange={(e) => onChange('include02Added', e.target.checked)}
              className="sr-only peer"
            />
            <div className="w-9 h-5 bg-zinc-700 rounded-full peer peer-checked:after:translate-x-full peer-checked:bg-blue-500 after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:rounded-full after:h-4 after:w-4 after:transition-all"></div>
          </label>
        </div>
      </div>

      <div className="bg-yellow-500/10 border border-yellow-500/20 rounded-xl p-4 text-yellow-400 flex gap-3 text-sm">
        <AlertTriangle className="w-5 h-5 flex-shrink-0" />
        <div>
          <p className="font-semibold">Cuidado con el alcance del Enhancement</p>
          <p className="text-xs text-yellow-500/80 mt-0.5">
            <code className="bg-black/30 px-1 rounded">MM06E001</code> puede estar ya en uso por otros desarrollos Z del cliente — valida en <code className="bg-black/30 px-1 rounded">CMOD</code> que ningún otro proyecto lo tenga bloqueado antes de activarlo.
          </p>
        </div>
      </div>
    </div>
  );
}
